import {
    type ClientObservableBackgroundJobStatus,
    type JobImportActionRequiredType,
} from "types/enum";

import { TemplateImportResponse } from "entity/templateImport/TemplateImport/TemplateImport.api.types";

export type ClientObservableBackgroundJobStatusFormActions = string | undefined;

export enum ProcessStatusGroupType {
    CostItemUpdate = 1,
    JobImportNew = 2,
    OrgToOrgCopy = 3,
    PlanUpload = 4,
    TodoToTaskMigration = 5,
    PlanSetDownload = 6,
}

export enum BackgroundProcessEntityType {
    Job = 1,
    JobTemplate = 2,
}

export interface IPlanUploadAdditionalData {
    setId?: string;
    isAddFile?: boolean;
    isTemplate?: boolean;
    // PlanSetDownload jobs carry the proxy URL + filename so the popup item
    // can trigger the anchor download once the merge finishes.
    downloadUrl?: string;
    fileName?: string;
    errorMessage?: string;
    // Mass-revisions jobs carry the draft id so the caller can open the review modal once
    // the analyze/match job finishes.
    draftId?: string;
}

interface IClientObservableBackgroundJobDetailsData {
    processId: string;
    processName: string;
    details: string;
    status: ClientObservableBackgroundJobStatus;
    processType: ProcessStatusGroupType;
    entityId: number | null;
    entityType: BackgroundProcessEntityType | null;
    additionalData?: IPlanUploadAdditionalData;
}

export class ClientObservableBackgroundJobDetails {
    constructor(data: IClientObservableBackgroundJobDetailsData) {
        this.processID = data.processId;
        this.processName = data.processName;
        this.details = data.details;
        this.status = data.status;
        this.processType = data.processType;
        this.entityId = data.entityId;
        this.entityType = data.entityType;
        this.additionalData = data.additionalData;
    }
    processID: string;
    processName: string;
    details: string;
    status: ClientObservableBackgroundJobStatus;
    processType: ProcessStatusGroupType;
    entityId: number | null;
    entityType: BackgroundProcessEntityType | null;
    additionalData?: IPlanUploadAdditionalData;
}

interface IClientObservableBackgroundJobStatusesData {
    jobs: IClientObservableBackgroundJobDetailsData[];
}

export class ClientObservableBackgroundJobStatuses {
    constructor(data: IClientObservableBackgroundJobStatusesData) {
        this.backgroundJobStatuses = data.jobs.map(
            (x) => new ClientObservableBackgroundJobDetails(x),
        );
        this.backgroundJobStatuses.reverse();
    }
    backgroundJobStatuses: ClientObservableBackgroundJobDetails[];
}
export class ClearClientObservableBackgroundJobStatusesResponse {}

export interface IProcessStatusGroupState {
    showProcessGroup: boolean;
    isPanelExpanded: boolean;
}

interface IActionRequiredJobExtraDataInput {
    shouldShowLinkCustomer: boolean;
    shouldTurnCalendarOffline: boolean;
    leadId?: number | null;
}

interface IJobImportActionRequiredResponseData {
    actionRequiredType: JobImportActionRequiredType;
    jobId: number;
    scheduleExtraData?: ConstructorParameters<typeof TemplateImportResponse>[0];
    jobExtraData?: IActionRequiredJobExtraDataInput;
}

class ActionRequiredJobExtraData {
    constructor(data: IActionRequiredJobExtraDataInput) {
        this.shouldShowLinkCustomer = data.shouldShowLinkCustomer;
        this.shouldTurnCalendarOffline = data.shouldTurnCalendarOffline;
        this.leadId = data.leadId ?? undefined;
    }

    shouldShowLinkCustomer: boolean;
    shouldTurnCalendarOffline: boolean;
    leadId?: number;
}

export class JobImportActionRequiredResponse {
    constructor(data: IJobImportActionRequiredResponseData) {
        this.actionRequiredType = data.actionRequiredType;
        this.jobId = data.jobId;
        this.scheduleExtraData = data.scheduleExtraData
            ? new TemplateImportResponse(data.scheduleExtraData)
            : undefined;
        this.jobExtraData = data.jobExtraData
            ? new ActionRequiredJobExtraData(data.jobExtraData)
            : undefined;
    }

    actionRequiredType: JobImportActionRequiredType;
    jobId: number;
    scheduleExtraData?: TemplateImportResponse;
    jobExtraData?: ActionRequiredJobExtraData;
}
